import { render, staticRenderFns } from "./OpticsRefractionViz.vue?vue&type=template&id=9c162f54&scoped=true"
import script from "./OpticsRefractionViz.vue?vue&type=script&lang=js"
export * from "./OpticsRefractionViz.vue?vue&type=script&lang=js"
import style0 from "./OpticsRefractionViz.vue?vue&type=style&index=0&id=9c162f54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c162f54",
  null
  
)

export default component.exports